import { useTranslation } from '@mc/i18n'

export const PersonalizedImageSkeleton = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='col-12 col-md-11 mc-m-auto'>
      <div
        className='mc-corners--lg mc-overflow--hidden mc-background--color-medium'
        style={{ aspectRatio: '3/2', width: '100%' }}
      ></div>

      <div className='d-flex flex-column align-items-start mc-mt-2'>
        <h3
          className='mc-background--color-medium mc-corners--md'
          style={{ width: 300 }}
        >
          &nbsp;
        </h3>
        <p
          className='mc-mt-2 mc-background--color-medium mc-corners--md'
          style={{ width: 400 }}
        >
          &nbsp;
        </p>
      </div>
      <div className='d-flex align-items-center justify-content-center mc-mt-10'>
        <p className='mc-text--center mc-text-color--tint'>
          {t('findMyClasses.fullAccess.subtitle')}
        </p>
      </div>
    </div>
  )
}
